<template>
  <div class="bg-white p-5 pb-1 pt-4 mt-4 rounded">
    <h4 class="title-primary">Nuevos administradores</h4>

    <create-user-form
      :clients="clients"
      :urlvalidateemail="urlvalidateemail"
      :url="url"
      :token="token"
      :issuperadmin="issuperadmin"
      @user-created="handleUserCreated"
      @form-reset="handleFormReset"
    />

    <bulk-upload-user
      :clients="clients"
      :url="url"
      :token="token"
      @upload-completed="handleUploadSuccess"
      @upload-success="handleUploadSuccess"
      @upload-error="handleUploadError"
    />
  </div>
</template>

<script>
import CreateUserForm from './CreateUserForm.vue'
import BulkUploadUser from './BulkUploadUser.vue'

export default {
  name: 'CreateUserContainer',
  
  components: {
    CreateUserForm,
    BulkUploadUser
  },
  
  props: {
    url: { type: String, default: '' },
    token: { type: String, default: '' },
    rol: { type: [String, Object, Array], default: '' },
    get: { type: String, default: '' },
    clients: { type: Array, default: () => [] },
    empresas: { type: Array, default: () => [] },
    urlvalidateemail: { type: String, default: '' },
    issuperadmin: { type: Boolean, default: false }
  },
  
  emits: ['user-created'],
  
  data() {
    return {
      lastUser: {}
    };
  },
  
  methods: {
    handleUserCreated(userData) {
      this.lastUser = { ...userData };
      this.$emit('user-created', true);
    },
    
    handleFormReset() {
      this.lastUser = {};
    },
    
    handleUploadSuccess(response) {
      this.$emit('user-created', true);
    },
    
    handleUploadError(error) {
      console.error('Upload error:', error);
    }
  }
}
</script>

<style scoped>
.title-primary {
  color: #1A0054;
  font-weight: bold;
}
</style>